{
  "sitemaps": {
    "title": "Plans du site",
    "page_content": "Les sitemaps vous permettent d'intégrer des dessins CAO détaillés des sites et des emplacements sur la carte. Vous pouvez ajouter et gérer des plans de site et des dessins CAO ci-dessous.",
    "no_sitemaps_title": "C'est un peu vide ici...",
    "no_sitemaps_body_1": "Il n'y a actuellement aucun lieu ou plan de site clé ! Cliquez sur ",
    "no_sitemaps_body_2": " bouton pour ajouter autant de lieux que vous le souhaitez",
    "add_sitemap": "Ajouter un plan du site",
    "create_sitemap_comming_soon_message": "Le téléchargement automatique des dessins CAO sera bientôt disponible. En attendant, notre équipe d'assistance peut télécharger vos fichiers CAO pour vous.",
    "click_to_open_sitemap_options": "Cliquez pour ouvrir les options du plan de site",
    "edit_sitemap": "Modifier le plan du site",
    "delete_sitemap": "Supprimer le plan du site"
  },
  "user_settings": "Réglages utilisateur",
  "help": "Aide",
  "help_menu": {
    "title": "Aide et ressources",
    "getting_started": "Démarrer avec Iventis",
    "knowledge_base": "Base de connaissances Iventis",
    "support": "soutien",
    "about": "À propos d'Iventis"
  },
  "sso": {
    "title": "Configuration SSO",
    "page_content": "Vous pouvez modifier ici la configuration SSO du projet",
    "response_signing_certificate": "Certificat de signature de réponse",
    "meta_data_location": "URL des métadonnées du fournisseur d'identité",
    "identity_provider": "Identifiant de l'entité du fournisseur d'identité",
    "saved": "Configuration SSO enregistrée avec succès",
    "setup_description": "Lorsque vous configurez le SSO avec votre fournisseur d'identité, vous devez sélectionner SAML et saisir les propriétés suivantes",
    "entity_id": "ID d'entité",
    "rely_url": "URL de réponse",
    "signon_url": "URL de connexion",
    "sso_enabled": "SSO activé",
    "enable_confirmation": "Êtes-vous sûr de vouloir activer le SSO pour ce projet ?",
    "enable_confirmation_warning": "Assurez-vous que le SSO est correctement configuré avant de l'activer pour éviter d'exclure les utilisateurs du projet",
    "disable_confirmation": "Êtes-vous sûr de vouloir désactiver le SSO pour ce projet ?",
    "disable_confirmation_warning": "La désactivation de l'authentification unique obligera tous les utilisateurs qui utilisent actuellement l'authentification unique à définir un mot de passe. Ils recevront un e-mail contenant des instructions pour créer leur mot de passe afin de conserver l'accès au projet.",
    "disable_confirmation_warning2": "Une fois le SSO désactivé, il faudra réactiver manuellement l'accès SSO pour chaque utilisateur pour le réactiver."
  },
  "projectCustomisation": {
    "projectNameWarning": "La modification du nom du projet aura pour effet de modifier les paramètres suivants :",
    "projectNameWarningSsoKey": "Donc :",
    "projectNameWarningSsoValue": "URL de configuration (si activées)",
    "projectNameWarningUrlKey": "URL du projet :"
  },
  "projectRolePermissions": {
    "projectAdministratorsSubMenu": "Administrateurs de projet",
    "projectAdministratorsTitle": "Administrateurs de projet",
    "projectAdminRoleDescription": "Vous pouvez y ajouter ou supprimer des administrateurs de projet. Ces utilisateurs ont accès à toutes les données, paramètres et autorisations du projet et peuvent les modifier.",
    "addAdmin": "Ajouter un utilisateur",
    "addProjectAdmin": "Ajouter un administrateur de projet",
    "removeAdmin": "Supprimer le statut d'administrateur",
    "removeAdminConfirm": "Cette personne ne sera plus administrateur de projet. Désirez-vous continuer ?",
    "removeYourselfAdminConfirm": "Vous perdrez l'accès administrateur du projet et ne pourrez pas le rajouter à nouveau. Désirez-vous continuer ?",
    "projectAdminsSelectedConfirmButton": "Ajouter la sélection",
    "addAdminsToast": "Admins ajoutés avec succès",
    "removeAdminToast": "L'administrateur a été supprimé avec succès"
  }
}